import React from "react";
import { View, StyleSheet, TouchableOpacity } from "react-native";
import Text from "@components/CustomText";
import { tokens } from "../../PartnerRoutingAndPacking/styles";
import { getInitials, formatPingAge, getAvatarColors } from "../utils";

const DbListItem = ({ db, onPress }) => {
  // Non-OFD DBs render greyed out below the OFD group.
  const muted = !db.is_ofd;
  const colors = muted
    ? { bg: tokens.bg, fg: tokens.textTertiary }
    : getAvatarColors(db.name || db.phone);
  return (
    <TouchableOpacity
      style={[styles.row, muted && styles.rowMuted]}
      activeOpacity={0.7}
      onPress={onPress}
    >
      <View
        style={[
          styles.avatar,
          { backgroundColor: colors.bg, borderColor: colors.fg },
        ]}
      >
        <Text style={[styles.initials, { color: colors.fg }]}>
          {getInitials(db.name)}
        </Text>
      </View>
      <View style={styles.nameBlock}>
        <View style={styles.nameRow}>
          <Text
            variant="title_16"
            style={[muted ? styles.nameMuted : styles.name, styles.nameText]}
            numberOfLines={1}
          >
            {db.name || db.phone}
          </Text>
          {db.is_ofd ? (
            <View style={styles.ofdPill}>
              <Text style={styles.ofdPillText}>OFD</Text>
            </View>
          ) : null}
        </View>
        <Text variant="caption_2" style={styles.phone} numberOfLines={1}>
          {db.phone}
        </Text>
      </View>
      <Text variant="caption_2" style={styles.ping}>
        {formatPingAge(db.ping_age_sec)}
      </Text>
      {db.is_ofd ? <Text style={styles.chevron}>›</Text> : null}
    </TouchableOpacity>
  );
};

export default DbListItem;

const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: tokens.spacing.large,
    paddingVertical: tokens.spacing.medium,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: tokens.borderLight,
  },
  avatar: {
    width: 38,
    height: 38,
    borderRadius: 19,
    borderWidth: 1.5,
    alignItems: "center",
    justifyContent: "center",
    marginRight: tokens.spacing.medium,
  },
  initials: {
    fontSize: 13,
    fontWeight: "700",
  },
  rowMuted: { opacity: 0.55 },
  nameBlock: { flex: 1, paddingRight: tokens.spacing.small },
  nameRow: { flexDirection: "row", alignItems: "center" },
  nameText: { flexShrink: 1 },
  name: { color: tokens.textPrimary, fontWeight: "600" },
  nameMuted: { color: tokens.textSecondary, fontWeight: "600" },
  ofdPill: {
    backgroundColor: tokens.pill.new.bg,
    borderColor: tokens.pill.new.border,
    borderWidth: 1,
    borderRadius: tokens.radius.full,
    paddingHorizontal: tokens.spacing.small,
    paddingVertical: 1,
    marginLeft: tokens.spacing.small,
  },
  ofdPillText: {
    color: tokens.pill.new.fg,
    fontSize: 10,
    fontWeight: "700",
    letterSpacing: 0.4,
  },
  phone: { color: tokens.textSecondary, marginTop: 2 },
  ping: { color: tokens.textTertiary },
  chevron: {
    color: tokens.textTertiary,
    fontSize: 20,
    marginLeft: tokens.spacing.small,
  },
});
